import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Auth, idToken } from '@jfw/angular/shared/firebase/auth';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { SKIP_TOKEN_INTERCEPTOR } from './skip-token-interceptor';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private auth: Auth = inject(Auth);

  // Intercept all outgoing HTTP requests and add the user's Firebase token to the header
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return idToken(this.auth).pipe(
      take(1),
      switchMap((token) => {
        const skipInterceptor = request.context.get(SKIP_TOKEN_INTERCEPTOR);
        if (token && !skipInterceptor) {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          });
        }
        return next.handle(request);
      }),
    );
  }
}
